import { ReactNode, useCallback } from "react";
import { useSetRecoilState } from "recoil";

import { applicationModalStore } from "store/applicationModalStore";

export const useApplicationModal = () => {
  const setModal = useSetRecoilState(applicationModalStore);

  const openApplicationModal = useCallback(
    (component: ReactNode) => {
      setModal({ modalState: "open", component });
    },
    [setModal]
  );

  const closeApplicationModal = useCallback(() => {
    setModal({ modalState: "close", component: null });
  }, [setModal]);

  return { openApplicationModal, closeApplicationModal };
};
